export default __webpack_public_path__ + "caret-down.png";